import { BaseService } from './BaseService';
import { ApolloQueryResult } from 'apollo-client';
import { FetchResult } from 'apollo-link';
import fetchNotificationsQuery from '@/graphql/queries/FetchNotifications.gql';
import readNotifications from '@/graphql/mutations/ReadNotifications.gql';

import {
  readNotification,
  NotificationReadInput,
  fetchNotifications
} from '../types/graphql/schemaTypes';

class NotificationService extends BaseService {
  public fetchNotifications(
    notificationArgs?: {
      language?: string;
    },
    paginationArgs?: {
      page?: number;
      per?: number;
    }
  ): Promise<ApolloQueryResult<fetchNotifications>> {
    return this.client.query({
      query: fetchNotificationsQuery,
      variables: {
        paginationArgs,
        notificationArgs
      }
    });
  }

  public readNotifications(notificationArgs?: NotificationReadInput):
   Promise<FetchResult<readNotification>> {
    return this.client.mutate({
      mutation: readNotifications,
      variables: {
        notificationArgs
      }
    });
  }
}

export const notificationService = new NotificationService();
